

















import Vue from "vue";
import { Icons, LearningHistoryExerciseLog, ExerciseType, Skill } from "@tt-app/models";
import { getExerciseIcon } from "@tt-app/utils";

import iconBronzeTrophy from "@joyz/app-core/assets/trophy/small/Bronze.svg";
import iconCheck from "@joyz/app-core/assets/icons/Correct.svg";
import iconGoldTrophy from "@joyz/app-core/assets/trophy/small/Gold.svg";
import iconSilverTrophy from "@joyz/app-core/assets/trophy/small/Silver.svg";

interface Data {
  icons: Icons;
}

interface Computed {
  correctIcon: boolean;
  label: string;
  parent: string;
  statusIcon: string;
  exerciseTypeIcon: string;
}

interface Props {
  log: LearningHistoryExerciseLog;
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: "LearningHistoryExerciseLog",
  props: {
    log: { type: Object, required: true }
  },
  data() {
    return {
      icons: {
        trophies: {
          1: iconBronzeTrophy,
          2: iconSilverTrophy,
          3: iconGoldTrophy
        },
        check: iconCheck
      }
    };
  },
  computed: {
    correctIcon() {
      return this.statusIcon.includes("Correct");
    },
    exerciseTypeIcon() {
      const exerciseType = (this.log.exercise.type as unknown) as ExerciseType;
      const exerciseSkill = (this.log.exercise.skill as unknown) as Skill;
      return getExerciseIcon(exerciseType, exerciseSkill);
    },
    label() {
      const i18nKey = this.log.assignment
        ? "learning-history.label.assignment"
        : "learning-history.label.course";

      return this.$__(i18nKey);
    },
    parent() {
      return this.log.assignment ? this.log.assignment.title : this.log.course.title;
    },
    statusIcon(): string {
      if (this.log.trophy === null) {
        if (this.log.timestamp) {
          return this.icons.check as string;
        } else {
          return "";
        }
      }

      return (this.icons.trophies as Icons)[this.log.trophy] as string;
    }
  }
});
